<div class="flex items-start w-full gap-3">
  <span
    class="mt-2 rounded-full w-2 h-2 shrink-0"
    [class.bg-primary-500]="isUnread()"
    aria-hidden="true"
  ></span>

  <div class="flex flex-col min-w-0 gap-0.5">
    <span
      class="text-sm leading-5 text-gray-900"
      [class.font-semibold]="isUnread()"
      [class.font-medium]="!isUnread()"
    >
      {{ notification().title }}
    </span>

    @if (notification().body) {
      <span class="text-sm leading-5 text-secondary line-clamp-2">{{ notification().body }}</span>
    }

    @if (createdAt(); as created) {
      <span
        class="mt-0.5 text-xs text-hint tabular-nums"
        [title]="created | date: 'dd MMM yyyy HH:mm'"
      >
        {{ createdAtLabel() }}
      </span>
    }
  </div>
</div>
